import { render, staticRenderFns } from "./DepartmentRatingDirectionsIndex.vue?vue&type=template&id=22b30d63"
import script from "./DepartmentRatingDirectionsIndex.vue?vue&type=script&lang=js"
export * from "./DepartmentRatingDirectionsIndex.vue?vue&type=script&lang=js"
import style0 from "./DepartmentRatingDirectionsIndex.vue?vue&type=style&index=0&id=22b30d63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports